import React, { useState, useRef, useEffect, forwardRef } from 'react'
import { styles } from './style'
import Loader from '../loader'
import { trimUpperCase } from '../../../utils/utils'

const Dropdown = (props, ref) => {
  const { options = {}, showLoader = false, errorMsg = '', label = '', value = '', id = '', showList, forceOpen, showIcon = false,
    onClick = () => { }, disabled = false, fieldTestId = '', placeholderText = '', type = '',
    withCheckbox = false, initialCheckboxState = {}, onCheckbox, suggestionsWidth = '158px', isSelected = false, customePosition = 'absolute'
  } = props
  const [dropdownOpen, setDropdownOpen] = useState(false)
  let listItems = useRef()
  let activeEl = null
  function displayErrorMessage() {
    if (errorMsg) {
      return errorMsg.length < 55
        ? <div style={styles.errorMsgContainer}>{errorMsg}</div>
        : <div style={styles.errorMsgContainerLengthy}>{errorMsg}</div>
    } else {
      return <span />
    }
  }

  const openDropdown = () => {
    disabled ? setDropdownOpen(false) : setDropdownOpen(true)
  }

  const closeDropdown = () => {
    setDropdownOpen(false)
  }

  const selectItem = (value) => {
    setDropdownOpen(false)
    onClick(value, type)
  }

  const selectCheckbox = (keyword) => {
    onCheckbox(keyword, !initialCheckboxState[keyword])
  }
  useEffect(() => {
    if (showList) {
      setDropdownOpen(true)
    }
  }, [showList])

  useEffect(() => {
    if (forceOpen) {
      setDropdownOpen(true)
    }
  }, [forceOpen])

  useEffect(() => {
    dropdownOpen && listItems.current.focus()
  }, [dropdownOpen])

  return (
    <div>
      <div data-testid='dropdown-head-container' style={disabled ? styles.disabledMainContainer : styles.mainContainer}>
        <div style={styles.container}>
          <div style={value ? styles.textWithArrow : styles.labelWithArrow} onClick={openDropdown} id={id} >
            <div data-testid={fieldTestId} style={withCheckbox ? styles.labelCheckbox(isSelected) : value ? styles.value : styles.label}>
              {value || placeholderText} {showIcon && <img style={{ marginLeft: '6px', position: 'absolute' }} src={'/icons/ic_asterisk_district.svg'} />}
            </div>
            {!showLoader && <img src='/icons/ic_down_arrow.svg' style={styles.downArrow} />}
            <Loader show={showLoader} />
          </div>
        </div>
      </div>
      {
        dropdownOpen &&
        <div data-testid='dropdown-container' style={{ position: 'relative', maxHeight: '189px' }}>
          <ul style={{ ...styles.suggestions, width: suggestionsWidth, position: customePosition }} ref={listItems} tabIndex={1}
          >
            {!withCheckbox &&
              Object.keys(options).map((option, index) => {
                return (
                  <div key={index} data-id={option} style={value === options[option] ?
                    styles.listDivWithData :
                    styles.listDiv}
                    onClick={selectItem.bind(props, option)}>
                    <li data-testid={`dropdown-${index}`} value={option} key={index} style={styles.list}>
                      {options[option]}
                    </li>
                  </div>
                )
              })}
            {withCheckbox &&
              Object.keys(options).map((option, index) => {
                return (
                  <div key={index} data-id={option} style={value === options[option] ?
                    styles.listDivWithData :
                    styles.listDiv}
                    onClick={selectCheckbox.bind(props, option)}>
                    <img src={initialCheckboxState[option] ? "/icons/ic_checkbox_selected.svg" : "/icons/ic_checkbox_unselected.svg"}
                      style={{ paddingLeft: '11px' }} />
                    <li data-testid={`dropdown-${index}`} value={option} key={index} style={styles.listCheckBox}>
                      {options[option]}
                    </li>
                  </div>
                )
              })}
          </ul>
        </div>
      }
      {displayErrorMessage()}
    </div >
  )
}

export default Dropdown